import clsx from "clsx";
import React from "react";

const DateBlock = ({ date, theme = "light" }) => {
  return (
    <div
      className={clsx(
        "flex w-16 h-16 lg:h-[5rem] lg:w-[5rem] flex-col items-center justify-center rounded leading-none",
        {
          "bg-white text-gray-900": theme === "light",
          "bg-gray-900 text-white": theme === "dark",
        },
      )}
    >
      <div className={clsx("text-center text-sm leading-[1]")}>
        {date.format("ddd")}
      </div>
      <div className={clsx("text-center text-3xl font-light leading-[1]")}>
        {date.format("D/M")}
      </div>
    </div>
  );
};

export default DateBlock;
